import { _ as r } from "../internals/export.js";
import { f as t } from "../internals/function-uncurry-this.js";
import { i as e } from "../internals/is-array.js";
var s = t([].reverse),
  i = [1, 2];
r({
  target: "Array",
  proto: !0,
  forced: String(i) === String(i.reverse())
}, {
  reverse: function reverse() {
    return e(this) && (this.length = this.length), s(this);
  }
});